import ax from "../../shared/utils/http_client"

export const CartItem = () => ({
  quantity: 1,
  id: null,
  stock: null,
  stockMessage: '',

  init() {
    this.quantity = parseInt(this.$el.dataset.itemQuantity) || 1
    this.id = this.$el.dataset.itemId
    this.stock = this.$el.dataset.itemStock ? parseInt(this.$el.dataset.itemStock) : null

    if (this.stock !== null && this.quantity > this.stock) {
      this.quantity = this.stock
      this.stockMessage = `庫存僅剩 ${this.stock} 件，已為您調整數量`
      setTimeout(() => this.stockMessage = '', 3000)
    } else {
      this.stockMessage = ''
    }
    this.updateCartItem()
  },

  get currentQuantity() {
    // 從購物車狀態中獲取當前數量
    const cart = this.$store.frontend.cart
    if (!cart || !cart.items) return this.quantity

    const item = cart.items.find(item => item.id === this.id)
    return item ? item.quantity : this.quantity
  },

  get show() {
    // 檢查購物車狀態中是否有這個商品項目
    const cart = this.$store.frontend.cart
    if (!cart || !cart.items) return false

    const item = cart.items.find(item => item.id === this.id)
    return item && item.quantity > 0
  },

  get isSelected() {
    const cart = this.$store.frontend.cart
    if (!cart || !cart.items) return false

    const item = cart.items.find(item => item.id === this.id)
    return item ? item.selected : false
  },

  get isDisabled() {
    const cart = this.$store.frontend.cart
    if (!cart || !cart.items) return false

    const item = cart.items.find(item => item.id === this.id)
    if (!item) return false

    // 如果商品已選中，則不禁用
    if (item.selected) return false

    // 檢查是否可以選擇這個品牌
    return !this.$store.frontend.canSelectBrand(item.brand)
  },

  get isStockMaxed() {
    if (this.stock === null) return false; // 無限庫存
    return this.currentQuantity >= this.stock;
  },

  increment() {
    if (this.isStockMaxed) {
      return;
    }
    this.quantity = this.currentQuantity + 1
    this.updateCartItem()
  },

  decrement() {
    if (this.currentQuantity > 1) {
      this.quantity = this.currentQuantity - 1
      this.updateCartItem()
    }
  },

  remove() {
    if (confirm("確定刪除此商品？")) {
      this.quantity = 0
      this.updateCartItem()
    }
  },

  async updateCartItem() {
    const result = await ax.patch(`/api/v1/cart/update_item`, {
      id: this.id,
      quantity: this.quantity,
    })

    this.$store.frontend.setCart(result.data.cart)

    this.notifySelectAllUpdate()
  },

  async toggleItem(event) {
    const itemId = this.$el.dataset.itemId
    const selected = event.target.checked
    const brandId = event.target.dataset.brandId

    this.updateItemUI(selected)

    if (brandId) {
      this.$dispatch("cart-item-changed")
    }

    try {
      const { data } = await ax.patch(`/api/v1/cart/toggle_item`, { id: itemId })
      this.$store.frontend.setCart(data.cart)

      this.notifySelectAllUpdate()
    } catch (error) {
      this.rollbackItem(!selected)
      if (error.response && error.response.data && error.response.data.error) {
        alert(error.response.data.error)
        // 如果有購物車資料，更新它
        if (error.response.data.cart) {
          this.$store.frontend.setCart(error.response.data.cart)
        }
      } else {
        console.error(error)
      }
    }
  },

  notifySelectAllUpdate() {
    this.$dispatch('cart-item-changed')
  },

  updateItemUI(selected) {
    const checkbox = this.$el.querySelector(".item-checkbox")
    if (checkbox) {
      checkbox.checked = selected
    }
  },

  // API 請求失敗時，將checkbox恢復到操作前的未勾選狀態
  rollbackItem(originalSelected) {
    this.updateItemUI(originalSelected)
  },
})
